import { useContext, useState, createContext } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../api';

export const AuthContext = createContext(null);

// "user_Id": "",
// "user_name": "",

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('LV-Auth') || null)
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('LV-User')) || {});
  const [loading, setLoading] = useState(false);
  const history = useHistory()

  const signin = async (userdata) => {
    try {
      setLoading(true);
      const res = await api.post('Accounts/Login', userdata)
      localStorage.setItem('LV-Auth', res.data.value.access_token)
      setToken(res.data.value.access_token)
      localStorage.setItem('LV-User', JSON.stringify(res.data.value));
      setUser(res.data.value);
      setLoading(false)
      return true;
    } catch (error) {
      setLoading(false)
      return error;
    }
  }

  const signup = async (userdata) => {
    try {
      setLoading(true);
      await api.post('Accounts/Register', userdata)
      userdata.role === 'Vendor' ? history.replace('/vendor-login') : history.replace('/login')
      setLoading(false)
      return true;
    } catch (error) {
      setLoading(false)
      return error;
    }
  }

  const logout = () => {
    try {
      setLoading(true);
      localStorage.removeItem('LV-Auth');
      localStorage.removeItem('LV-User');
      setLoading(false)
      setUser({});
      return true;
    } catch (error) {
      return error;
    }
  }

  return (
    <AuthContext.Provider value={{ signin, signup, logout, loading, token, user }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);
